import {
  createGlobalStyle
} from 'styled-components'

createGlobalStyle`
  .chart-base {
    /* Parent
    ------------------------------- */
    /* Childrens
    ------------------------------- */
    /* Modifiers
    ------------------------------- */
    &.is-modifier-name {}

    /* Media queries
    ------------------------------- */
  }
`
